import {
    AUTH_USER_SUCCESS
} from './actions'

const initialState = {
    countryCode: '',
    nroCellphone: '',
    nombreCliente: '',
    nroDocumento: '',
    tipoDocumento: '',
    challengeId: '',
    maskedPhone: '',
    maskedEmail: '',
    pinExpiresInSeconds: 0
}

export function reducer(state = initialState, action: any) {
    switch (action.type) {
        case AUTH_USER_SUCCESS:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state
    }
}
